<template>
  <div>
    <div>
      <Button type="primary" @click="addModalBtn">新增绑定门店</Button>
    </div>
    <Table stripe :columns="columns" :data="bindStoreList" style="width:1105px;margin-top:10px;"></Table>
    <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :current="page" :total="listTotal" :page-size="pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>
    <!-- 新增绑定门店弹窗 -->
    <Modal v-model="addDataModal.display" title="新增绑定门店" @on-ok='addStoreOk' ref="addDataModal" :loading='true'>
      <Form>
        <!-- <FormItem label="提示：" :label-width="90">
          <p style="line-height:34px;font-size:14px;">选择门店进行绑定</p>
        </FormItem> -->
        <FormItem label="绑定门店：" :label-width="90">
          <Select v-model="addDataModal.bindStore" filterable clearable style="width:300px" label-in-value @on-change='changeSelect'>
            <Option v-for="(item,index) in chainArr" :key='index' :value='item.sourceId'>{{item.sourceName}}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "@/utils";

export default {
  created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );
    this.cleanerId = Utils.getUrlParameterByName('id')
	},
  data () {
    return {
      listTotal:0,
      page:1,
      pageSize:10,
      bindStoreList:[],
      columns:[
        {
          title: '门店ID',
          key: 'chainId',
          align:'center',
          width: 160 
        },
        {
          title: '绑定门店',
          key: 'chainName',
          align:'center',
          width: 250 
        },
        {
          title: '绑定时间',
          key: 'ctime',
          align:'center',
          width: 250 
        },
        {
          title: '操作人',
          key: 'creator',
          align:'center',
          width: 220 
        },
        {
          title: '操作',
          key: 'id',
          align:'center',
          width: 220,
          render:(h,params)=>{
            return h('Button',
            {
              props: {
                type: 'primary'
              },
              on:{
                click:()=>{
                  this.$Modal.confirm({
                    title: "提示",
                    content: `<p style='font-size:15px;'>是否确认解除清洁员与门店绑定关系<p style='font-size:14px;color:red;'>解除绑定后，将不可指派清洁</p></p>`,
                    okText: "确认解除绑定",
                    cancelText: "取消",
                    onOk: () => {
                      this.cancelBind(params.row.id)
                    }
                  });
                }
              }
            },'解绑')
          }
        },
      ],
      // 弹窗
      chainArr:[],
      addDataModal:{
        display:false,
        bindStore:'',
        chainName:''
      }
    }
  },
  async mounted() {
    this.$Notice.config( {
			top: 200
    })
    this.queryBindDate()
    let selectListResp = ( await API.omsAPI[this.env].php.querySelectList() ).data;
    this.chainArr = selectListResp.data.chain
  },
  methods: {
    async queryBindDate(){
      let queryParams = {
        url:'/admin/xbCleanertAction/bindChainList',
        page:this.page,
        rows:this.pageSize,
        cleanerId:this.cleanerId
      }
      let resp = (await API.omsAPI[this.env].cleaner.xbedCleanApi(queryParams,this.token)).data
      if ( resp.retCode ) {
				this.$Notice.error({
					title: "获取绑定门店列表数据失败",
					desc: resp.msg
				});
				return
			}
      this.bindStoreList = resp.content
      this.listTotal = resp.totalCount
    },
    changePageSize(size){
      this.page = 1
      this.pageSize = size
      this.queryBindDate()
    },
    changePage(page){
      this.page = page
      this.queryBindDate()
    },
    // 新增绑定门店弹窗
    addModalBtn(){
      this.addDataModal.display = true;
    },
    changeSelect(item){
      this.addDataModal.chainName = item.label
    },
    // 确定新增绑定门店
    async addStoreOk(){
      if(!this.addDataModal.bindStore){
        this.$Notice.error({
					title: "请选择需要绑定的门店",
        });
        this.$refs.addDataModal.buttonLoading = false;
        return
      }
      let queryParams = {
        url:'/admin/xbCleanertAction/bindChain',
        chainId:this.addDataModal.bindStore,
        chainName:this.addDataModal.chainName,
        cleanerId:this.cleanerId,
        operatorName:this.username
      }
      let resp = (await API.omsAPI[this.env].cleaner.xbedCleanApi(queryParams,this.token)).data
      if(resp.retCode) {
        this.$Notice.error({
          title: '新增绑定失败',
          desc: resp.msg
        })
        this.$refs.addDataModal.buttonLoading = false;
        return
      }
      this.$Notice.success({
				title: "新增绑定成功",
				// desc: resp.msg
      });
      this.queryBindDate()
      this.addDataModal.display = false;
    },
    // 解除绑定
    async cancelBind(id){
      let queryParams = {
        url:'/admin/xbCleanertAction/unbindChain',
        id:id,
        operatorName:this.username
      }
      let resp = (await API.omsAPI[this.env].cleaner.xbedCleanApi(queryParams,this.token)).data
      if(resp.retCode) {
        this.$Notice.error({
          title: '解除绑定失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
				title: "解除绑定成功",
				// desc: resp.msg
      });
      this.queryBindDate()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/cleaner/housekeeper-account-edit/bind-store.vue